export function text(value: any): string {
  return `${value ?? ''}`;
}
